import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { appRoutesObj } from "src/app.paths";

function NavbarSignInButtonComponent() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(appRoutesObj.getSignInPagePath())}
      className={`flex flex-row justify-center items-center font-arMedium text-tart-500 bg-transparent border border-tart-500 rounded-xl text-xl w-40 h-11 mobile:text-sm mobile:w-[104px] mobile:h-9`}
    >
      {t("app.shared.signin")}
    </button>
  );
}

export default NavbarSignInButtonComponent;
